
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': '데이터 소스',
	'dataSourceId': 'ID',
	'dataSourceType': '유형',
	'dataSourceName': '이름',
	'dataSourcePath': '경로',
	'showInfoForAll': '모든 시각화에 대한 기간 표시',
	'hideInfoForAll': '모든 시각화에 대한 기간 숨기기',
	'showPerformanceDetails': '성능 상세 정보를 포함하도록 모든 위젯 재실행',
	'slotMappingField': '슬롯 맵핑',
	'slotDataMapping': '맵핑',
	'slotID': 'ID',
	'slotCaption': '캡션',
	'slotMandatory': '필수',
	'slotIsMandatory': '예',
	'slotIsNotMandatory': '아니오',
	'infoNotAvailable': '사용할 수 없음',
	'performanceSection': '성능',
	'durationField': '기간',
	'singleQueryTime': '서버 쿼리(밀리초)',
	'multipleQueryTime': '서버 쿼리 %{name}(밀리초)',
	'liveWidgetTotalTime': '합계(밀리초)',
	'renderTimeNotAvailable': '사용할 수 없음',
	'renderInProgress': '(진행 중)',
	'interactToTriggerQuery': '쿼리를 트리거하도록 위젯과 상호작용',
	'fetchQuery': '쿼리 페치',
	'showSQLMDX': 'SQL/MDX 표시',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': '쿼리 정보',
	'queryInfoNotAvailable': '쿼리 정보를 사용할 수 없음',
	'query': '쿼리',
	'copy': '복사',
	'close': '닫기'
});
